<template>
  <div>
    <Spinner v-if="loading.view"></Spinner>
    <template v-else>
      <Card :bodyClass="'p-0'" :noHeader="true">
        <Table :columns="columnsByService" :rows="list" :columnID="'idBibliaRegistro'">
          <template #headactions>
            <button class="btn btn-xs btn-icon btn-light-success" @click="onNew">
              <i class="fa fa-fw fa-plus"></i>
            </button>
          </template>
          <template #rows="{ rows }">
            <BibliaRegistrosRow
              v-for="row in rows"
              :key="row.idBibliaRegistro"
              :row="row"
            ></BibliaRegistrosRow>
          </template>
        </Table>
      </Card>
    </template>
  </div>
</template>
<script>
import Table from '../../shared/components/Table.vue';
import Card from '../../shared/components/Card.vue';
import BibliaRegistrosRow from './BibliaRegistrosRow.vue';
import Spinner from '../../shared/components/Spinner.vue';
import { getColumnsPerService, getTableColumns } from '../helpers/getColumnsPerService';

import { mapState } from 'vuex';

export default {
  props: ['biblia'],
  components: {
    Spinner,
    BibliaRegistrosRow,
    Card,
    Table,
  },
  data() {
    return {
      // nueva forma
      containers: {
        registros: [],
        agencias: [],
        servicio_tipos: [],
        idiomas: [],
        hoteles: [],
        asistentes: [],
        restaurantes: [],
      },
      loading: {
        view: true,
      },
    };
  },
  async created() {
    await this.fetchContainers();
  },
  computed: {
    ...mapState('biblia_registros', ['list']),
    columnsByService() {
      const columnsPerService = ['actions', ...getColumnsPerService(this.biblia.idServicio)];
      console.log('🚀 ~ columnsByService ~ columnsPerService', columnsPerService);
      return getTableColumns(columnsPerService);
    },
  },
  watch: {
    registros: {
      handler(newVal) {
        this.$emit('change', newVal ?? []);
      },
      deep: true,
    },
  },
  methods: {
    async fetchContainers() {
      let vm = this;

      let response = await vm.axios.get(`/biblias/${vm.biblia.idBiblia}/registros`, {
        params: {
          containers: 1,
        },
      });

      const list = response.data.content.registros.map((item) => {
        return {
          ...item,
          isNew: false,
          isEdit: false,
          tempAgencia: null,
          tempFile: '',
          tempNombre: '',
          tempTipo: '',
          tempPAX: '',
          tempCHD: '',
          tempIdioma: null,
          tempHotel: null,
          tempSacsayhuaman: null,
          tempQoricancha: null,
          tempHoraRecojo: '',
          tempIngresoBTG: '',
          tempIngresoCAT: '',
          tempIngresoQOR: '',
          tempAsistente: null,
          tempRecomendaciones: '',
          tempObservaciones: '',
          tempEstado: null,
          tempEnlaceTren: '',
          tempRestaurante: null,
          tempLunch: null,
          tempRecojoPisac: false,
        };
      });

      vm.$store.commit('biblia_registros/load', {
        sacsayhuamanColors: response.data.content.sacsayhuamanColors,
        servicio_tipos: response.data.content.servicioTipos,
        agencias: response.data.content.agencias,
        hoteles: response.data.content.hoteles,
        horas_recojo: response.data.content.hotelesHoras,
        idiomas: response.data.content.idiomas,
        restaurantes: response.data.content.restaurantes,
        asistentes: response.data.content.asistentes,
        list: list,
        biblia: vm.biblia,
      });

      vm.loading.view = false;
    },

    onNew() {
      this.$store.dispatch('biblia_registros/newItem');
    },
  },
};
</script>
